import { useEffect } from "react";
import { X } from "lucide-react";

export default function VideoModal({ open, video, onClose }) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose();
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", onKey);
        };
    }, [open, onClose]);

    if (!open || !video) return null;

    return (
        <div
            data-testid="video-modal"
            className="fixed inset-0 z-[100] flex items-center justify-center"
            role="dialog"
            aria-modal="true"
        >
            <button
                aria-label="Fermer"
                onClick={onClose}
                className="absolute inset-0 bg-black/85 backdrop-blur-sm"
                data-testid="video-modal-backdrop"
            />

            <div className="relative z-10 w-full max-w-[420px] mx-auto px-6 animate-fade-up">
                <div className="flex items-center justify-between mb-4 text-white">
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.28em] text-gold">
                            {video.category}
                        </p>
                        <p className="font-display text-xl mt-1">{video.title}</p>
                    </div>
                    <button
                        onClick={onClose}
                        data-testid="video-modal-close"
                        className="w-10 h-10 border border-white/30 flex items-center justify-center hover:bg-white hover:text-ink transition-colors"
                        aria-label="Fermer"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                <div className="relative aspect-[9/16] bg-bordeaux border border-white/10 overflow-hidden">
                    {video.video_url ? (
                        <video
                            data-testid="video-modal-player"
                            src={video.video_url}
                            poster={video.poster_url || undefined}
                            controls
                            autoPlay
                            playsInline
                            className="w-full h-full object-cover bg-black"
                        />
                    ) : (
                        <img
                            src={video.poster_url}
                            alt={video.title}
                            className="w-full h-full object-cover"
                        />
                    )}
                </div>

                <p className="mt-4 text-center text-[10px] uppercase tracking-[0.28em] text-white/50">
                    Cliquez en dehors ou appuyez sur ESC pour fermer
                </p>
            </div>
        </div>
    );
}
